import { render, staticRenderFns } from "./hospitalStatistics2023.vue?vue&type=template&id=7d2c48a5&scoped=true&"
import script from "./hospitalStatistics2023.vue?vue&type=script&lang=js&"
export * from "./hospitalStatistics2023.vue?vue&type=script&lang=js&"
import style0 from "./hospitalStatistics2023.vue?vue&type=style&index=0&id=7d2c48a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2c48a5",
  null
  
)

export default component.exports